// extracted by mini-css-extract-plugin
module.exports = {"pinkBadge":"PinkBadge-module--pinkBadge--1FTZn","md":"PinkBadge-module--md--wOWYT"};